
import React from 'react'
import { Modal } from '../shared/components/Modal'

type State = { error: Error|null }

function lastTraceInfo(){
  try {
    const v = sessionStorage.getItem('lastRequestInfo')
    return v ? JSON.parse(v) : null
  } catch { return null }
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, State>{
  constructor(props:any){ super(props); this.state = { error:null } }
  static getDerivedStateFromError(error: Error){ return { error } }
  componentDidCatch(error: Error){ console.error(error) }
  render(){
    const info = lastTraceInfo()
    return <>
      {this.props.children}
      <Modal open={!!this.state.error} onClose={()=>this.setState({error:null})} title="Something went wrong">
        <p className="text-sm">We hit an error. If you contact support, include the <code>trace_id</code> below.</p>
        <pre className="bg-gray-100 p-2 rounded text-xs overflow-auto mt-2">{JSON.stringify(info, null, 2)}</pre>
        {info?.trace_id && <a className="text-blue-600 underline text-sm" href={(import.meta.env.VITE_TRACE_EXPLORER||'#')+String(info.trace_id)} target="_blank">Open trace</a>}
      </Modal>
    </>
  }
}
